import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

// lore-mfe-kit initializes automatically on import
// Token management is handled by CommunicationBridge

// Entry point for Menu MFE application
const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App hostAuthResult={null} externalRefUserId="44016" />
  </React.StrictMode>
);

// Trigger workflow update for latest tag
